import { api } from '../configs/axiosConfigs';

export const createCommentNoteEntry = async (property_id: string, comment_id: string, body: string) => {
  return await api.post(`/properties/${property_id}/comments/${comment_id}/note_entries`, {
    note_entry: { body }
  });
};
